import { API, Auth } from "aws-amplify";
import { takeEvery, call, put, all } from "redux-saga/effects";
import * as participantsTypes from "../../constants/ParticipantsActionTypes";
import _ from "lodash";

import devConfig from "../../../aws-config-dev/aws-exports";
import prodConfig from "../../../aws-config-prod/aws-exports";
let awsConfig = process.env.REACT_APP_ENV === "production" ? prodConfig : devConfig;

function* getParticipants(action) {
  try {
    let { clinic, date } = action;

    console.time("start");
    let session = yield Auth.currentSession();
    let token = session.getIdToken().getJwtToken();
    let participants = yield API.get("multimedia-checklist", `/shoot/${clinic}/${date}/staff`, {
      headers: {
        Authorization: token
      }
    });
    participants = participants.map((interviewee, i) => {
      if (interviewee.hasAvatar) {
        interviewee.src = `https://${awsConfig.aws_user_files_s3_bucket}.s3.${awsConfig.aws_user_files_s3_bucket_region}.amazonaws.com/public/${clinic}/${date}/staff/${interviewee.id}/avatar/avatar-34.png`;
        return interviewee;
      } else return interviewee;
    });
    console.timeEnd("start");
    // console.log(participants);
    yield put({
      type: participantsTypes.PARTICIPANTS_FETCHED,
      participants
    });
  } catch (err) {
    console.log(err);
    yield put({
      type: participantsTypes.PARTICIPANTS_FAILED
    });
  }
}

function* watchGetParticipants() {
  yield takeEvery(participantsTypes.PARTICIPANTS_FETCHING, getParticipants);
}

export default {
  watchGetParticipants
};
